import {Component} from '@angular/core';
import {SocketServices} from '../services/socket.services';

@Component({
  selector:"dashboard",
  templateUrl:"../templates/dashboard.template.html"
})
export class DashboardComponent {

  constructor(private ss:SocketServices){}

}
